import React, { useState, useEffect } from "react";
import { Button, ButtonGroup, Dropdown, DropdownButton, Form, Accordion, Tabs, Tab, Row, Col } from "react-bootstrap";
import { SETTING_FORM_URL, UPLOAD_FORM_FILE_URL, VIEW_SETTING_URL } from "../../../../Constant/api";
import { authService } from "../../../../Service/Axios";
import { FORMBUILDER_FILE_TYPES, DEFAULT_MODULE_TYPE, DOCUMENT_TYPE_PDF_ONLY, IMAGE_TYPES, NON_DOCUMENT_TYPES } from "../../../../Constant/constants";
import { downloadFile } from "../../../../Utils";
import { toast } from "react-toastify";

const FileUpload = ({ status, setsettings, eleavailable, viewForm, setviewSetting, settings, seteleavailable, allElements, formId, setfirst, first, setviewForm, dynaDDselarr, drop }) => {

    const [inpValue, setinpValue] = useState(viewForm[0]?.value.length > 0 ? { filetype: viewForm[0]?.value[0], name: viewForm[0]?.value[1], size: viewForm[0]?.value[2], url: viewForm[0]?.value[3] } : { filetype: '', url: '', size: '', name: '' })

    useEffect(() => {
        setinpValue(viewForm[0]?.value.length > 0 ? { filetype: viewForm[0]?.value[0], name: viewForm[0]?.value[1], size: viewForm[0]?.value[2], url: viewForm[0]?.value[3] } : { filetype: '', url: '', size: '', name: '' })
    }, [viewForm[0]?.value?.length], [first])

    useEffect(() => {
        setinpValue(viewForm[0]?.value.length > 0 ? { filetype: viewForm[0]?.value[0], name: viewForm[0]?.value[1], size: viewForm[0]?.value[2], url: viewForm[0]?.value[3] } : { filetype: '', url: '', size: '', name: '' })
    }, viewForm[0]?.value, [first])

    const [flagFu, setflagFu] = useState(null);

    useEffect(() => {
        if (!settings) setflagFu(null)
    }, [settings])

    const handleDelete = (ID) => {
        seteleavailable(allElements.filter(item => item.questionId != ID))
    }

    const handleSetting = () => {
        // setopenset(k)
        viewSettingAction()
    }

    const viewSettingAction = async () => {

        const payload = { "formId": formId, "questionId": eleavailable[0]?.questionId, "elementType": eleavailable[0]?.typename, "sequenceNo": eleavailable[0]?.sequenceNo };
        const response = await authService(VIEW_SETTING_URL, "POST", payload);
        if (response) {
            setviewSetting(response)
        }
        setsettings(!settings)
    };

    const handleCopy = async () => {
        const temp = Math.floor(100000 + Math.random() * 900000)
        seteleavailable([...allElements, {
            ...eleavailable[0],
            questionId: temp,
            questionName: eleavailable[0]?.questionName + '_',
            label: eleavailable[0]?.label + '_',
        }])

        const payload = {
            elementType: eleavailable[0]?.typename,
            questionId: temp,
            formId: formId,
            sectionId: eleavailable[0]?.sectionId,
            label: eleavailable[0]?.label + '_',
            sequenceNo: allElements.length,
            editfield: {
                questionName: eleavailable[0]?.questionName + '_',
                placeholderText: eleavailable[0]?.placeholderText,
                fieldDescription: eleavailable[0]?.fieldDescription,
                required: eleavailable[0]?.required,
                hidden: eleavailable[0]?.hidden,
                internal: eleavailable[0]?.internal,
                columnSpan: eleavailable[0]?.columnSpan,
                parentQuestionName: eleavailable[0]?.parentQuestionName,
                dropdownValues: eleavailable[0]?.dropdownValues,
                fileuploadtypes: eleavailable[0]?.fileuploadtypes,
                mapping: eleavailable[0]?.mapping,
                objectmap: eleavailable[0]?.objectmap,
                fieldmap: eleavailable[0]?.fieldmap,
                sectionDescription: eleavailable[0]?.sectionDescription,
                paragraph: eleavailable[0]?.paragraph,
                autoSearch: eleavailable[0]?.autoSearch,
                autoSearchEvent: eleavailable[0]?.sectionId,
                uniqueValue: eleavailable[0]?.uniqueValue,
                autoSearchKey: eleavailable[0]?.autoSearchKey,
                gridRows: eleavailable[0]?.gridRows,
                gridColumns: eleavailable[0]?.gridColumns,
            },
            validateField: {
                fieldLength: false,
                minimumLength: eleavailable[0]?.minimumLength,
                maximumLength: eleavailable[0]?.maximumLength,
                charcterType: false,
                charcterTypeValue: eleavailable[0]?.charcterTypeValue,
                patternType: false,
                patternTypeValue: "",
                numericType: false,
                numericValue: eleavailable[0]?.numericValue,
                numberRange: false,
                numberRangeValue: "",
                measurement: false,
                measurementValue: "",
                negativeNumber: eleavailable[0]?.negativeNumber,
                validation: eleavailable[0]?.validation,
            },
            globalField: eleavailable[0]?.globalField,
            addrule: eleavailable[0]?.addrule,
            show: eleavailable[0]?.show,
            mainConditions: eleavailable[0]?.mainConditions,
            calculate: eleavailable[0]?.calculate,
            calculateType: eleavailable[0]?.calculateType,
            calculateValueType: eleavailable[0]?.calculateValueType,
            calculation: eleavailable[0]?.calculation,
            calulateOthersCond: eleavailable[0]?.calulateOthersCond,
            calulateOthersMultiSelect: eleavailable[0]?.calulateOthersMultiSelect,
            calulateOthersValue: eleavailable[0]?.calulateOthersValue,
            videoURL: eleavailable[0]?.videoURL,
            imageURL: eleavailable[0]?.imageURL,
            ratingNo: eleavailable[0]?.ratingNo,
            gridOneChoiceRow: eleavailable[0]?.gridOneChoiceRow,
            gridOneChoiceColumn: eleavailable[0]?.gridOneChoiceColumn,
            gridMultiChoceRow: eleavailable[0]?.gridMultiChoceRow,
        };
        const response = await authService(SETTING_FORM_URL, "POST", payload);
        if (response) {
            toast.success("Saved Setting!");
            // setType(response.elementType);
            setsettings(false);
        }
    }

    const uploadFile = async (file) => {
        // const file = e.target.files[0];
        const fileParts = file.type.split("/");
        const fileType = fileParts[1].toLowerCase();
        const formFiletypes = eleavailable[0]?.fileuploadtypes
            .length > 0 ? eleavailable[0].fileuploadtypes
            : viewForm[0]?.fileuploadtypes

        let fileSize = 0;
        if (formFiletypes.includes(fileType)) {

            const formData = new FormData();
            formData.append("file", file);
            formData.append("formId", formId);
            formData.append("appId", drop);
            formData.append("appType", DEFAULT_MODULE_TYPE.formBuilder);
            formData.append("questionId", viewForm[0]?.questionId);
            const response = await authService(
                UPLOAD_FORM_FILE_URL,
                "POST",
                formData
            );
            if (response) {
                setinpValue({ ...response, filetype: fileType })

                setviewForm({
                    formId: dynaDDselarr?.formId,
                    formName: dynaDDselarr?.formName,
                    description: dynaDDselarr?.description,
                    status: dynaDDselarr?.status,
                    pages: dynaDDselarr?.pages.map(item => {
                        return {
                            ...item,
                            sections: item.sections.map(i => {
                                return {
                                    sectionId: i.sectionId,
                                    name: i.name,
                                    label: i.label,
                                    description: i.description,
                                    questions: i?.questions?.map((item) => {
                                        if (item.questionId == viewForm[0]?.questionId) {
                                            item = { ...item, value: [fileType, response.name, response.size, response.url] }
                                        }
                                        return item;
                                    }),
                                    rules: i.rules,
                                    type: i.type,
                                    addrule: i.addrule,
                                    show: i.show,
                                    mainConditions: i.mainConditions,
                                    sectionDescription: i.sectionDescription,
                                }
                            })
                        }
                    })
                })

                setfirst(first.map((item) => {
                    if (item.questionId == viewForm[0]?.questionId) {
                        item = {
                            ...item,
                            value: [fileType, response.name, response.size, response.url]
                        };
                    }
                    return item;
                }))
            }
        } else {
            alert(`Please enter ${formFiletypes.toString()} file only`);
        }
    };

    const handleinpChange = (e) => {

        uploadFile(e.target.files[0])
    }

    const handleDrag = (e) => {
        e.preventDefault()
    }

    const handleDrop = (e) => {
        e.preventDefault()

        uploadFile(e.dataTransfer.files[0])
    }

    const handleRemove = () => {
        setinpValue({
            filetype: '', url: '', size: '', name: ''
        })

        setviewForm({
            formId: dynaDDselarr?.formId,
            formName: dynaDDselarr?.formName,
            description: dynaDDselarr?.description,
            status: dynaDDselarr?.status,
            pages: dynaDDselarr?.pages.map(item => {
                return {
                    ...item,
                    sections: item.sections.map(i => {
                        return {
                            sectionId: i.sectionId,
                            name: i.name,
                            label: i.label,
                            description: i.description,
                            questions: i?.questions?.map((item) => {
                                if (item.questionId == viewForm[0]?.questionId) {
                                    item = {
                                        ...item, value: [""]
                                    }
                                }
                                return item;
                            }),
                            rules: i.rules,
                            type: i.type,
                            addrule: i.addrule,
                            show: i.show,
                            mainConditions: i.mainConditions,
                            sectionDescription: i.sectionDescription,
                        }
                    })
                }
            })
        })

        setfirst(first.map((item) => {
            if (item.questionId == viewForm[0]?.questionId) {
                item = {
                    ...item,
                    value: [""]
                };
            }
            return item;
        }))
    }

    return (
        <Col className="mt-2 mb-2" xxl={eleavailable[0]?.columnSpan == 1 ? 12 : viewForm[0]?.columnSpan == 1 && eleavailable[0]?.columnSpan != 1 && !settings ? 12 : viewForm[0]?.columnSpan == 1 && eleavailable[0]?.columnSpan == 1 && settings ? 12 : 6} xl={eleavailable[0]?.columnSpan == 1 ? 12 : viewForm[0]?.columnSpan == 1 && eleavailable[0]?.columnSpan != 1 && !settings ? 12 : viewForm[0]?.columnSpan == 1 && eleavailable[0]?.columnSpan == 1 && settings ? 12 : status == "save" ? 12 : 6} lg={12} md={12} sm={12} xs={12}>
            <div className={`${(status == `preview` ||
                status == `In Progress` ||
                status == `Submitted` ||
                status == "Published") && !viewForm[0]?.internal
                ? `builder-row border rounded-2 bg-light preview-field`
                : (status == `preview` ||
                    status == `In Progress` ||
                    status == `Submitted` ||
                    status == "Published") && viewForm[0]?.internal ?
                    `builder-row border rounded-2 bg-light preview-field d-none` : flagFu == eleavailable[0]?.questionId ? `builder-row border rounded-2 bg-light active` : `builder-row border rounded-2 bg-light`}`}>
                <div className="builder-row-header py-2 px-3 border-bottom d-flex">
                    <h4>
                        <span className="material-symbols-outlined align-middle me-2">
                            upload
                        </span>{" "}
                        File Upload
                    </h4>
                    <div className="button-list ms-auto d-flex">
                        <Button variant="transparent"><span className="material-symbols-outlined align-middle copy-btn me-2" onClick={(e) => { setflagFu(eleavailable[0]?.questionId); handleSetting(); }}>settings</span></Button>
                        <Button variant="transparent">
                            <span className="material-symbols-outlined align-middle copy-btn me-2"
                                onClick={handleCopy}>
                                content_copy
                            </span>
                        </Button>
                        <Button variant="transparent"><span className="material-symbols-outlined align-middle remove-btn" onClick={(e) => handleDelete(eleavailable[0]?.questionId)}>delete</span></Button>
                    </div>
                </div>
                <div className="builder-row-body d-flex flex-wrap">
                    <div className="drag-btn d-flex justify-content-center align-items-center border-end">
                        <Button variant="transparent"><span className="material-symbols-outlined">drag_indicator</span></Button>
                    </div>
                    <div className="builder-field p-3">
                        <Form.Group className="mb-3" controlId="shorttext">
                            <Form.Label>{eleavailable[0]?.label.length > 0 ? eleavailable[0].label : viewForm[0]?.label.length > 0 ? viewForm[0]?.label : "Add your question here"} {eleavailable[0]?.required ? <span className="text-danger"> *</span> : viewForm[0]?.required && !eleavailable[0]?.required && !settings ? <span className="text-danger"> *</span> : viewForm[0]?.required && eleavailable[0]?.required && settings ? <span className="text-danger"> *</span> : <span></span>}
                                <small className="d-block">{eleavailable[0]?.fieldDescription.length > 0 ? eleavailable[0].fieldDescription : viewForm[0]?.fieldDescription}</small>
                            </Form.Label>
                            {(status == `preview` || status == `In Progress` || status == `Submitted` || status == "Published") ?
                                <div
                                    className={`file-input-box bg-white border rounded ${(eleavailable[0]?.required
                                        ? eleavailable[0].required
                                        : viewForm[0]?.required && inpValue?.filetype.length <= 0 && dynaDDselarr?.mandatory)
                                        ? `is-invalid`
                                        : ``
                                        }`}
                                >
                                    {inpValue?.name?.length > 0 ?
                                        <div className="d-block p-5 text-center">
                                            {
                                                (["png"].includes(inpValue.filetype)) &&
                                                <span className="file-format">
                                                    <div className="format-icon">
                                                        <i className="bx bxs-file-png"></i>
                                                    </div>
                                                    <div className="file-name-des">
                                                        <span className="file-title">
                                                            <h6>{inpValue.name}</h6>
                                                        </span>
                                                        <span className="file-size">
                                                            <h5>{inpValue.size < 1000000 ? Math.floor(inpValue.size / 1000) + "KB"
                                                                : Math.floor(inpValue.size / 1000000) + "MB"}</h5>
                                                        </span>
                                                    </div>
                                                    <ButtonGroup aria-label="Basic example">
                                                        <a href={inpValue?.url} target="_blank" className="pt-2"
                                                        >
                                                            <i className="bx bx-show-alt bx-xs text-successs"></i>
                                                        </a>
                                                        <Button style={dynaDDselarr?.status == "Submitted" ? { pointerEvents: "none" } : {}} variant="transparent" onClick={handleRemove}><i className="bx bx-trash bx-xs text-danger"></i></Button>
                                                    </ButtonGroup>
                                                </span>
                                            }
                                            {
                                                (["jpeg"].includes(inpValue.filetype)) &&
                                                <span className="file-format">
                                                    <div className="format-icon">
                                                        <i className="bx bxs-file-jpg"></i>
                                                    </div>
                                                    <div className="file-name-des">
                                                        <span className="file-title">
                                                            <h6>{inpValue.name}</h6>
                                                        </span>
                                                        <span className="file-size">
                                                            <h5>{inpValue.size < 1000000 ? Math.floor(inpValue.size / 1000) + "KB"
                                                                : Math.floor(inpValue.size / 1000000) + "MB"}</h5>
                                                        </span>
                                                    </div>
                                                    <ButtonGroup aria-label="Basic example">
                                                        <a href={inpValue?.url} target="_blank" className="pt-2"
                                                        >
                                                            <i className="bx bx-show-alt bx-xs text-successs"></i>
                                                        </a>
                                                        <Button style={dynaDDselarr?.status == "Submitted" ? { pointerEvents: "none" } : {}} variant="transparent" onClick={handleRemove}><i className="bx bx-trash bx-xs text-danger"></i></Button>
                                                    </ButtonGroup>
                                                </span>
                                            }
                                            {
                                                (["pdf"].includes(inpValue.filetype)) &&
                                                <span className="file-format">
                                                    <div className="format-icon">
                                                        <i className="bx bxs-file-pdf"></i>
                                                    </div>
                                                    <div className="file-name-des">
                                                        <span className="file-title">
                                                            <h6>{inpValue.name}</h6>
                                                        </span>
                                                        <span className="file-size">
                                                            <h5>{inpValue.size < 1000000 ? Math.floor(inpValue.size / 1000) + "KB"
                                                                : Math.floor(inpValue.size / 1000000) + "MB"}</h5>
                                                        </span>
                                                    </div>
                                                    <ButtonGroup aria-label="Basic example">
                                                        <a href={inpValue?.url} target="_blank" className="pt-2"
                                                        >
                                                            <i className="bx bx-show-alt bx-xs text-successs"></i>
                                                        </a>
                                                        <Button style={dynaDDselarr?.status == "Submitted" ? { pointerEvents: "none" } : {}} variant="transparent" onClick={handleRemove}><i className="bx bx-trash bx-xs text-danger"></i></Button>
                                                    </ButtonGroup>
                                                </span>
                                            }
                                            {
                                                (["vnd.openxmlformats-officedocument.wordprocessingml.document"].includes(inpValue.filetype)) &&
                                                <span className="file-format">
                                                    <div className="format-icon">
                                                        <i className="bx bxs-file-doc"></i>
                                                    </div>
                                                    <div className="file-name-des">
                                                        <span className="file-title">
                                                            <h6>{inpValue.name}</h6>
                                                        </span>
                                                        <span className="file-size">
                                                            <h5>{inpValue.size < 1000000 ? Math.floor(inpValue.size / 1000) + "KB"
                                                                : Math.floor(inpValue.size / 1000000) + "MB"}</h5>
                                                        </span>
                                                    </div>
                                                    <ButtonGroup aria-label="Basic example">
                                                        <a href={inpValue?.url} target="_blank" className="pt-2"
                                                        >
                                                            <i className="bx bx-show-alt bx-xs text-successs"></i>
                                                        </a>
                                                        <Button style={dynaDDselarr?.status == "Submitted" ? { pointerEvents: "none" } : {}} variant="transparent" onClick={handleRemove}><i className="bx bx-trash bx-xs text-danger"></i></Button>
                                                    </ButtonGroup>
                                                </span>
                                            }
                                        </div> :
                                        <>
                                            <label for={`file-${viewForm[0]?.questionId}`} className="d-block p-5 text-center" onDragOver={handleDrag} onDrop={handleDrop}>
                                                <span className="material-symbols-outlined">
                                                    cloud_upload
                                                </span>
                                                <h5 className="mb-0">
                                                    <strong>Choose file</strong> or{" "}
                                                    <strong>Drag here</strong>
                                                </h5>
                                            </label>
                                            <input type="file" id={`file-${viewForm[0]?.questionId}`} className="d-none" onChange={handleinpChange} required={eleavailable[0]?.required ? true : viewForm[0]?.required && !eleavailable[0]?.required && !settings ? true : viewForm[0]?.required && eleavailable[0]?.required && settings ? true : false} />
                                        </>}
                                </div>
                                :
                                <div
                                    className={`file-input-box bg-white border rounded ${(eleavailable[0]?.required
                                        ? eleavailable[0].required
                                        : viewForm[0]?.required && inpValue?.filetype.length <= 0 && dynaDDselarr?.mandatory)
                                        ? `is-invalid`
                                        : ``
                                        }`}
                                    style={{ pointerEvents: "none" }}>
                                    {inpValue?.name?.length > 0 ?
                                        <div className="d-block p-2 text-center">
                                            {
                                                (["png"].includes(inpValue.filetype)) &&
                                                <span className="">
                                                    <div className="format-icon">
                                                        <i className="bx bxs-file-png"></i>
                                                    </div>
                                                    <div className="file-name-des">
                                                        <span className="file-title">
                                                            <h6>{inpValue.name}</h6>
                                                        </span>
                                                        <span className="file-size">
                                                            <h5>{inpValue.size < 1000000 ? Math.floor(inpValue.size / 1000) + "KB"
                                                                : Math.floor(inpValue.size / 1000000) + "MB"}</h5>
                                                        </span>
                                                    </div>
                                                    <ButtonGroup aria-label="Basic example">
                                                        <a href={inpValue?.url} target="_blank" className="pt-2"
                                                        >
                                                            <i className="bx bx-show-alt bx-xs text-successs"></i>
                                                        </a>
                                                        <Button variant="transparent" onClick={handleRemove}><i className="bx bx-trash bx-xs text-danger"></i></Button>
                                                    </ButtonGroup>
                                                </span>
                                            }
                                            {
                                                (["jpeg"].includes(inpValue.filetype)) &&
                                                <span className="">
                                                    <div className="format-icon">
                                                        <i className="bx bxs-file-jpg"></i>
                                                    </div>
                                                    <div className="file-name-des">
                                                        <span className="file-title">
                                                            <h6>{inpValue.name}</h6>
                                                        </span>
                                                        <span className="file-size">
                                                            <h5>{inpValue.size < 1000000 ? Math.floor(inpValue.size / 1000) + "KB"
                                                                : Math.floor(inpValue.size / 1000000) + "MB"}</h5>
                                                        </span>
                                                    </div>
                                                    <ButtonGroup aria-label="Basic example">
                                                        <a href={inpValue?.url} target="_blank" className="pt-2"
                                                        >
                                                            <i className="bx bx-show-alt bx-xs text-successs"></i>
                                                        </a>
                                                        <Button variant="transparent" onClick={handleRemove}><i className="bx bx-trash bx-xs text-danger"></i></Button>
                                                    </ButtonGroup>
                                                </span>
                                            }
                                            {
                                                (["pdf"].includes(inpValue.filetype)) &&
                                                <span className="">
                                                    <div className="format-icon">
                                                        <i className="bx bxs-file-pdf"></i>
                                                    </div>
                                                    <div className="file-name-des">
                                                        <span className="file-title">
                                                            <h6>{inpValue.name}</h6>
                                                        </span>
                                                        <span className="file-size">
                                                            <h5>{inpValue.size < 1000000 ? Math.floor(inpValue.size / 1000) + "KB"
                                                                : Math.floor(inpValue.size / 1000000) + "MB"}</h5>
                                                        </span>
                                                    </div>
                                                    <ButtonGroup aria-label="Basic example">
                                                        <a href={inpValue?.url} target="_blank" className="pt-2"
                                                        >
                                                            <i className="bx bx-show-alt bx-xs text-successs"></i>
                                                        </a>
                                                        <Button variant="transparent" onClick={handleRemove}><i className="bx bx-trash bx-xs text-danger"></i></Button>
                                                    </ButtonGroup>
                                                </span>
                                            }
                                            {
                                                (["vnd.openxmlformats-officedocument.wordprocessingml.document"].includes(inpValue.filetype)) &&
                                                <span className="">
                                                    <div className="format-icon">
                                                        <i className="bx bxs-file-doc"></i>
                                                    </div>
                                                    <div className="file-name-des">
                                                        <span className="file-title">
                                                            <h6>{inpValue.name}</h6>
                                                        </span>
                                                        <span className="file-size">
                                                            <h5>{inpValue.size < 1000000 ? Math.floor(inpValue.size / 1000) + "KB"
                                                                : Math.floor(inpValue.size / 1000000) + "MB"}</h5>
                                                        </span>
                                                    </div>
                                                    <ButtonGroup aria-label="Basic example">
                                                        <a href={inpValue?.url} target="_blank" className="pt-2"
                                                        >
                                                            <i className="bx bx-show-alt bx-xs text-successs"></i>
                                                        </a>
                                                        <Button variant="transparent" onClick={handleRemove}><i className="bx bx-trash bx-xs text-danger"></i></Button>
                                                    </ButtonGroup>
                                                </span>
                                            }
                                        </div> :
                                        <>
                                            <label for={`file-${viewForm[0]?.questionId}`} className="d-block p-5 text-center" onDragOver={handleDrag} onDrop={handleDrop}>
                                                <span className="material-symbols-outlined">
                                                    cloud_upload
                                                </span>
                                                <h5 className="mb-0">
                                                    <strong>Choose file</strong> or{" "}
                                                    <strong>Drag here</strong>
                                                </h5>
                                            </label>
                                            <input type="file" id={`file-${viewForm[0]?.questionId}`} className="d-none" onChange={handleinpChange} />
                                        </>}
                                </div>
                            }
                        </Form.Group>
                    </div>
                </div>
            </div>
        </Col>
    )
}

export default FileUpload